import { isAdminView, isBrandSessionView, isBarberSessionView, isAgentView } from '../session';
export var getUrlPrefixFromView = function (view) {
    if (isAdminView(view) || isAgentView(view)) {
        return '/admin';
    }
    if (isBrandSessionView(view)) {
        return '/brand';
    }
    if (isBarberSessionView(view)) {
        return '/barber';
    }
    return '';
};
